<div
  class="image-card-container d-flex flex-column justify-content-end align-items-sm-start gp-24"
  [style.background-image]="
    linearGradient + ', url(&quot;' + (imgL | gpuMediaQuery: imgS) + '&quot;)'
  "
>
  <ng-content select="app-image-card-tag"></ng-content>

  <div [class.gmb-8]="!!description">
    <ng-content select="app-image-card-title"></ng-content>
  </div>

  <div [class.gmb-16]="!!button">
    <ng-content select="app-image-card-description"></ng-content>
  </div>

  <ng-content select="app-image-card-button"></ng-content>

  <ng-content></ng-content>
</div>
